import { __awaiter, __generator } from "tslib";
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { CopilotAdminPinningStatus, CopilotUserPinningStatus, } from '@office-start/copilot-types';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useCallback, useEffect } from 'react';
import { create } from 'zustand';
import { applyUserSettingChange } from '../userSettingContext';
import { getAdminPinningStatus, getUserPinningStatus, getUserStorageOptions, } from '../utils/utilities';
var useCopilotUserAdminSettingStore = create(function (set) { return ({
    userSetting: CopilotUserPinningStatus.Default,
    adminSetting: CopilotAdminPinningStatus.Default,
    updateUserSetting: function (userSetting) {
        return set({ userSetting: userSetting });
    },
    updateAdminSetting: function (adminSetting) {
        return set({ adminSetting: adminSetting });
    },
}); });
/**
 * Custom hook to manage user and admin settings for Copilot pinning.
 *
 * @returns A tuple containing:
 *   - The current user pinning status (CopilotUserPinningStatus).
 *   - The current admin pinning status (CopilotAdminPinningStatus).
 *   - A function to update the user pinning status.
 */
export function useCopilotUserAdminSetting() {
    var _this = this;
    var _a, _b;
    var _c = useCopilotUserAdminSettingStore(), userSetting = _c.userSetting, adminSetting = _c.adminSetting, updateUserSetting = _c.updateUserSetting, updateAdminSetting = _c.updateAdminSetting;
    var context = useOfficeComponentContext().data;
    var userEntitlements = useUserEntitlements().data;
    useEffect(function () {
        var _a, _b;
        updateAdminSetting(getAdminPinningStatus((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotAdminSetting));
        updateUserSetting(getUserPinningStatus((_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.userCopilotUserSetting));
    }, [
        updateAdminSetting,
        updateUserSetting,
        (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotAdminSetting,
        (_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.userCopilotUserSetting,
    ]);
    var updateUserSettingWrapped = useCallback(function (newSetting) { return __awaiter(_this, void 0, void 0, function () {
        var userStorageOptions, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!context) {
                        return [2 /*return*/, false];
                    }
                    userStorageOptions = getUserStorageOptions(context);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, applyUserSettingChange({
                            userPinningStatus: newSetting,
                            userStorageOptions: userStorageOptions,
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [context]);
    return {
        userSetting: userSetting,
        adminSetting: adminSetting,
        updateUserSetting: updateUserSettingWrapped,
    };
}
//# sourceMappingURL=useCopilotUserAdminSetting.js.map